import { render, staticRenderFns } from "./PlusHeaderUserAvatar.vue?vue&type=template&id=3f9ef5e1"
import script from "./PlusHeaderUserAvatar.vue?vue&type=script&lang=js"
export * from "./PlusHeaderUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports